module.exports = __webpack_public_path__ + "static/media/little-victory-group.2539bd44.png";